import { Currency } from '@/core/currency/interfaces';

const DJF: Currency = {
    name: 'Djiboutian Franc',
    demonym: 'Djiboutian',
    majorSingle: 'Franc',
    majorPlural: 'Francs',
    codeNumeric: '262',
    symbol: 'Fdj',
    symbolNative: 'ف.ج.',
    minorSingle: 'Centime',
    minorPlural: 'Centimes',
    ISOdigits: 0,
    decimals: 0,
    numToBasic: 100,
    code: 'DJF',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default DJF;
